import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoginPage from './service/LoginPage';
import Home from './service/Home';
import Usuarios from './service/Usuarios';
import SelecionaEntidade from './service/SelecionaEntidade';
import Entidades from './service/Entidades';
import CatmatImport from './service/CatmatImport';
import CatmatUmImport from './service/CatmatUmImport';
import Demandas from './service/Demandas';
import CatserImport from './service/CatserImport';
import CatserUmImport from './service/CatserUmImport';
import SessionsAtivas from './service/SessionsAtivas';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/seleciona_entidade" element={<SelecionaEntidade />} />
        <Route path="/entidades" element={<Entidades />} />
        <Route path="/catmat_import" element={<CatmatImport />} />
        <Route path="/demandas" element={<Demandas />} />
        <Route path="/catmatum_import" element={<CatmatUmImport />} />
        <Route path="/catser_import" element={<CatserImport />} />
        <Route path="/catserum_import" element={<CatserUmImport />} />
        <Route path="/sessions-ativas" element={<SessionsAtivas />} />
      </Routes>
    </Router>
  );
}

export default App;
